import { saveAs } from 'file-saver'
import axios from 'axios'
import ES6Promise from 'es6-promise'
import store from '@/store'
import router from '@/router'
import msg from '@/common/msg'
import * as code from '@/common/code'
import Encoding from 'encoding-japanese'

ES6Promise.polyfill()

const URL = process.env.NODE_SERVER_API

axios.defaults.baseURL = URL
axios.defaults.headers.common['contentType'] = 'application/json'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Cache-control'] = 'no-store'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.headers.common['Expires'] = 0

axios.CancelToken = axios.CancelToken
axios.isCancel = axios.isCancel
axios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('tokenSalmon')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.header && response.data.header.resultCode === code.serverErr) {
      store.commit('toggleModal', {
        show: true,
        message: msg.serverErr
      })
    }
    return Promise.resolve(response)
  },
  (err) => {
    const { response, message } = err
    if (message === 'Network Error') {
      return Promise.reject(msg.noInternet)
    } else if (response && response.status && response.status !== 401) {
      store.commit('toggleModal', {
        show: true,
        message: msg.serverErr
      })
    } else {
      store.dispatch('doLogout')
      router.push('/login')
      return
    }
    return Promise.reject(err)
  }
)

export default {
  // type: get, post, put
  ajaxRequest (type, path, params = null, data = null, success, error, customHeaders = {}) {
    axios.request({
      url: path,
      params: params,
      data: data,
      method: type,
      headers: customHeaders
    }).then(response => {
      if (response) {
        return success(response)
      }
    }).catch(err => {
      return error(err)
    })
  },
  ajaxDownloadRequest (path, params = null, data = null, success, error, fileName) {
    axios.post(path, {
      params,
      data: data,
      responseType: 'blob'
    })
      .then(response => {
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const blob = new Blob([bom, response.data], {
          type: response.data.type
        })
        saveAs(blob, fileName, true)
      })
  },
  ajaxDownloadRequestShiftJis (path, params = null, data = null, success, error, fileName) {
    axios.post(path, {
      params,
      data: data,
      responseType: 'blob'
    })
      .then(response => {
        // convert encoding. (utf-8 → shift-jis)
        const unicodeList = Encoding.stringToCode(response.data)
        const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode')
        const shiftJisString = new Uint8Array(shiftJisCodeList)

        // save
        let blob = new Blob([shiftJisString], {type: 'text/csv;charset=sjis'})
        saveAs(blob, fileName, true)
      })
  },
  ajaxPdfDownloadRequest (path, params = null, success, error, fileName) {
    axios.get(path, {
      params,
      responseType: 'blob'
    })
      .then(response => {
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const blob = new Blob([bom, response.data], {
          type: response.data.type
        })
        saveAs(blob, fileName, true)
      })
  },
  ajaxOpenFileDownloadRequest (path, params = null, success, error, fileName) {
    axios.get(path, {
      params,
      responseType: 'blob'
    })
      .then(response => {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' }
        )

        const fileURL = window.URL.createObjectURL(file)

        window.open(fileURL, '_blank')

        success && success(response)
      })
  },

  get (path, params, success, error) {
    return this.ajaxRequest('GET', path, params, {}, success, error)
  },
  post (path, data, success, error, customHeaders = {}) {
    return this.ajaxRequest('POST', path, {}, data, success, error, customHeaders)
  },
  put (path, data, success, error) {
    return this.ajaxRequest('PUT', path, {}, data, success, error)
  },
  del (path, data, success, error) {
    return this.ajaxRequest('DELETE', path, {}, data, success, error)
  },
  download (path, data, success, error, fileName) {
    return this.ajaxDownloadRequest(path, {}, data, success, error, fileName)
  },
  downloadShiftJis (path, data, success, error, fileName) {
    return this.ajaxDownloadRequestShiftJis(path, {}, data, success, error, fileName)
  },
  pdfDownload (path, params, success, error, fileName) {
    return this.ajaxPdfDownloadRequest(path, params, success, error, fileName)
  },
  openFileDownload (path, params, success, error, fileName) {
    return this.ajaxOpenFileDownloadRequest(path, params, success, error, fileName)
  },

  getByResponseType (path, params, success, error, responseType) {
    return this.ajaxRequestByResponseType('GET', path, params, {}, success, error, {}, responseType)
  },
  ajaxRequestByResponseType (type, path, params = null, data = null, success, error, customHeaders = {}, responseType = 'blob') {
    axios.request({
      url: path,
      params: params,
      data: data,
      method: type,
      headers: customHeaders,
      responseType: responseType
    }).then(response => {
      if (response) {
        return success(response)
      }
    }).catch(err => {
      return error(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/axios.js